import React, { useState, useEffect } from 'react';
import { Button, makeStyles, Typography, Box, Container, TextField } from '@material-ui/core';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import Fade from '@material-ui/core/Fade';
import Grow from '@material-ui/core/Grow';
import Layout from '../../components/Layout/Layout';
import HomeImage from '../../assets/images/home-img.svg';
import { themeGreen } from '../../theme';
import { Link } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';


const useStyles = makeStyles(theme => ({
    MainWrapper: { },
    CategorySelector: {
        marginTop: theme.spacing(5)
    },
    CenterWrapper: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        width: '100%',
        height: 'calc(100vh - 66px)',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            justifyContent: 'flex-start'
        }
    },

    IllustrationWrapper: {
        maxWidth: '50%',
        '& img': {
            width: '100%',
            maxWidth: '500px'
        },
        alignSelf: 'center',        
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },

    FormWrapper: {
        width: '500px',
        maxWidth: '500px',
        display: 'flex',
        flexDirection: 'column',
        // margin: `${theme.spacing(5)}px auto 0`
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '0 15px',
            margin: '0 auto',
            order: 0,
            height: '100%',
            justifyContent: 'center'    
        }
    },
    title: {
        width: '100%',
        //color: theme.palette.common.white,
        fontSize: '55px',
        lineHeight: 1.2,
        fontWeight: 500,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            fontSize: '45px',            
        }
    },
    subtitle: {
        width: '100%',
        //color: theme.palette.common.white,
        fontSize: '28px',
        fontWeight: 100,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px'            
        },
        '& span' : {
            fontWeight: 500,            
        }
    },
    ActionsWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(3)
    }
}))

export default withWidth()(function Home(props) {
    const classes = useStyles(themeGreen);
    const [open, setOpen] = React.useState(false);
    const [categories, setCategories] = React.useState([]);    
    const [loading, setLoading] = useState(false);  
    const [value, setValue] = React.useState();
    const [showForm, setShowForm] = React.useState(false);            
    const [transitionsHandler, setTransitionHandler] = React.useState(
        {
            inForIllustration: false,
            inForTitle: false,
            inForSubtitle: false,
            inForButton: false
        }
    )


    useEffect(() => {    

        let active = true;

        (async () => {
            const response = await fetch(`https://www.agroads.com.ar/reviews/api/es.asp?action=categories`);
            const categoriesAux = await response.json();
            if (active) {
                setCategories(categoriesAux.aggregations.rubro2.buckets.map(r => ({
                    id: r.rubro2_id.buckets[0].key,
                    title: r.key
                })))
            }
        })();


        if (!isWidthUp('sm', props.width)) {
            setTimeout(() => {
                setShowForm(true);
            }, 1400)

            setTimeout(() => {
                window.scrollTo({ top: 360, left: 0, behavior: 'smooth' })
            }, 1400)
        }

        setTimeout(() => {
            setTransitionHandler(prevState => ({...prevState, inForTitle : true }))
        }, 200);
        
        setTimeout(() => {
            setTransitionHandler(prevState => ({ ...prevState, inForIllustration: true }))
        }, 300);
        
        setTimeout(() => {
            setTransitionHandler(prevState => ({ ...prevState, inForSubtitle: true }))
        }, 1000);

        setTimeout(() => {
            setTransitionHandler(prevState => ({ ...prevState, inForButton: true }))
        }, 1500);

    }, []);

    const handleNext = () => {
        if (value && value !== 0)
            props.history.push(`/r/${value}/modelo/`);
    }
    

    return (
        <Layout loading={loading}>
            <Container maxWidth="lg">
                <Box className={classes.CenterWrapper}>
                    
                    <div className={classes.FormWrapper}>
                        <Fade in={transitionsHandler.inForTitle} timeout={1600}>
                            <div>
                                <Typography className={classes.title}>Opiniones de Equipos Agrícolas.</Typography>
                            </div>
                        </Fade>
                        <Fade in={transitionsHandler.inForSubtitle} timeout={1500}>
                            <div>
                                <Typography className={classes.subtitle}>
                                    ¿Tenés o tuviste maquinaria agrícola? ¡Queremos saber tu experiencia!                                            
                                </Typography>                                                                    
                            </div>                                
                        </Fade>
                        <Fade in={transitionsHandler.inForButton} timeout={ 2000 }>
                            <div className={classes.CategorySelector}>                                
                                <Autocomplete
                                    id="combo-box-demo"
                                    open={open}
                                    onOpen={() => {
                                        setOpen(true);
                                    }}
                                    onClose={() => {
                                        setOpen(false);
                                    }}                                    
                                    getOptionSelected={(option, value) => option.title === value.title}
                                    getOptionLabel={(option) => option.title}
                                    options={categories}
                                    loading={loading}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            placeholder="Buscá una categoría"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }} />
                                    }
                                    fullWidth
                                    onChange={(event, newValue) => {
                                        setValue(newValue ? newValue.id : 0);
                                    }}
                                />
                                <div className={classes.ActionsWrapper}>
                                    <Button color="primary" variant="contained" className={classes.SubmitBtn} onClick={() => handleNext()} disabled={value === 0 || !value}>Continuar</Button>
                                </div>
                            </div>
                        </Fade>
                    </div>
                    <div className={classes.IllustrationWrapper}>
                        <Fade in={transitionsHandler.inForIllustration} timeout={2000}>
                            <div>
                                <Grow in={transitionsHandler.inForIllustration} timeout={2000}>
                                    {/* <img src={isWidthUp('sm', props.width) ? bgImgDesktop : bgImgMobile} alt="Portada Agroads Precios" /> */}
                                    <img src={HomeImage} alt="Agroads Reseñas"/>
                                </Grow>
                            </div>
                        </Fade>
                    </div>                
                </Box>
            </Container>
            
        </Layout>
    )
});